import AntThinkingElement from './AntThinking';

export const markdownElements = [AntThinkingElement];
